import React from "react";
import PropTypes from "prop-types";

// Under table-layout: fixed the column can no longer grow to fit an outlier
// value the way auto layout used to - a value with no spaces (an ID, a URL)
// would otherwise overflow straight across the neighbouring columns instead
// of wrapping. The tooltip columns get this via .max-two-line; plain cells
// need it applied directly since they carry no other overflow handling.
//
// overflow-wrap alone isn't enough: this span is a flex item (inside
// AT.CellContainer), and flex items default to min-width: auto, which keeps
// them from ever shrinking below their content's intrinsic (unbroken) width
// no matter what the wrap rule says. minWidth: 0 overrides that default so
// the wrap can actually take effect.
const BREAK_WORD_STYLE = { overflowWrap: "break-word", minWidth: 0 };

const NAME_LINK_STYLE = {
	expanded: { cursor: "pointer", color: "white", ...BREAK_WORD_STYLE },
	collapsed: { color: "rgb(17, 100, 206)", cursor: "pointer", ...BREAK_WORD_STYLE },
};

// The "name" column is a link through to the service layout, unless the task
// has no stages to link to (disableLink).
const PlainCell = ({ col, value, toggle, disableLink, onNameClick }) => {
	const isNameLink = col === "name" && !disableLink;
	return (
		<span
			className="lastSpan"
			draggable="true"
			style={isNameLink ? NAME_LINK_STYLE[toggle ? "expanded" : "collapsed"] : BREAK_WORD_STYLE}
			onClick={isNameLink ? onNameClick : undefined}
		>
			{value}
		</span>
	);
};

PlainCell.propTypes = {
	col: PropTypes.string.isRequired,
	value: PropTypes.node,
	toggle: PropTypes.bool.isRequired,
	disableLink: PropTypes.bool,
	onNameClick: PropTypes.func,
};

export default PlainCell;
